import { MapLocation, PurchaseScreenTypePlan, SearchItemType, SearchSortFilter } from '@alltrails/analytics/amplitudeEnums';
import { pathToRegexp } from 'path-to-regexp';
import Coupon from 'types/Coupon';
import PlanCode from 'types/PlanCode';
import { AlgoliaResultType } from 'types/Search/Algolia';
import { Sort } from 'types/Search/Sort';

const typeMapping = {
  [AlgoliaResultType.Trail]: SearchItemType.Trail,
  [AlgoliaResultType.Track]: SearchItemType.Track,
  [AlgoliaResultType.Place]: SearchItemType.Place,
  [AlgoliaResultType.List]: SearchItemType.List,
  [AlgoliaResultType.Area]: SearchItemType.Area,
  [AlgoliaResultType.Map]: SearchItemType.Map,
  [AlgoliaResultType.Filter]: SearchItemType.Attribute,

  // TODO DISCO-604 map to the actual Amplitude analytics when ready.
  [AlgoliaResultType.POI]: AlgoliaResultType.POI as unknown as SearchItemType
};

const sortMapping = {
  [Sort.BEST_MATCH]: SearchSortFilter.BestMatch,
  [Sort.CLOSEST]: SearchSortFilter.Closest,
  [Sort.MOST_POPULAR]: SearchSortFilter.MostPopular,
  [Sort.NEWLY_ADDED]: SearchSortFilter.NewlyAdded,

  // These aren't tracked in Amplitude today. Just return the original sort value cast as an Amplitude value.
  [Sort.NAME]: Sort.NAME as unknown as SearchSortFilter,
  [Sort.LIST_ORDER]: Sort.LIST_ORDER as unknown as SearchSortFilter,
  [Sort.DATE]: Sort.DATE as unknown as SearchSortFilter,
  [Sort.RECENTLY_ADDED]: Sort.RECENTLY_ADDED as unknown as SearchSortFilter
};

function algoliaTypeToAmplitudeType(algoliaResultType: AlgoliaResultType): SearchItemType {
  return typeMapping[algoliaResultType];
}

function sortToAmplitudeSort(sort: Sort): SearchSortFilter {
  return sortMapping[sort];
}

function getPurchaseScreenTypePlan(planCode: PlanCode, coupon?: Coupon): PurchaseScreenTypePlan {
  if (coupon) {
    return PurchaseScreenTypePlan.Promo;
  }

  if (planCode === PlanCode.SevenDayTrial) {
    return PurchaseScreenTypePlan.FreeTrial;
  }

  return PurchaseScreenTypePlan.NonTrial;
}

// Based on getPageTitle from RoutePath.js
function getMapLocation(url: string): MapLocation {
  if (pathToRegexp('/:locale?/trail/(.*)').test(url) || pathToRegexp('/:locale?/explore/trail/(.*)').test(url)) {
    return MapLocation.Trail;
  }

  if (pathToRegexp('/:locale?/members/:slug/recordings').test(url) || pathToRegexp('/:locale?/explore/recording/(.*)').test(url)) {
    return MapLocation.Activity;
  }

  if (pathToRegexp('/:locale?/members/:slug/maps').test(url) || pathToRegexp('/:locale?/explore/map/(.*)').test(url)) {
    return MapLocation.SavedMap;
  }

  if (pathToRegexp('/:locale?/community(.*)').test(url)) {
    return MapLocation.Community;
  }

  return MapLocation.Explore;
}

export { algoliaTypeToAmplitudeType, getPurchaseScreenTypePlan, sortToAmplitudeSort, getMapLocation };
